import { combineReducers } from 'redux-immutable';
import { routerReducer } from 'react-router-redux';

// Import reducers

export default combineReducers({
  routing: routerReducer
});